export default __webpack_public_path__ + "assets/img/logo-000e38362a731a6cb001d02719a6cfe0.png";